import Model from '@/models/Model'

export default class GTypeAccountBank extends Model {
    resource() {
        return 'g_type_account_bank'
    }
}